import { useQuery } from '@apollo/client';
import { GetOrganizationPreferencesDocument } from '@/__generated__/graphql';

/**
 * El `hour12` de la organización, el fallback de la región cuando el usuario no lo define. Reutiliza
 * `GetOrganizationPreferences` del código existente: comparte caché con `useFormatters`.
 *
 * `skip` evita la query cuando no hace falta (la región del usuario ya define `hour12`).
 * Devuelve `null` si la organización no lo define, se saltó o no llegó.
 */
export function useOrganizationHour12({ skip }: { skip: boolean }): boolean | null {
  const { data } = useQuery(GetOrganizationPreferencesDocument, { skip });
  return skip ? null : data?.organization.preferences.hour12 ?? null;
}
